function filterOutEmpty<T>(items: T[]): T[] {
	return items.filter((item) => !!item);
}

export { filterOutEmpty };
